<template>
    <div class="core_strengths">
        <menuBox :step="2"></menuBox>
        <img src="../assets/banner-1.png" class="banner">
        <div class="text">
            由深諳國際市場環境的資深團隊為國內品牌企業提供海外社交媒體平台的運營管理服務，以國際化視野開拓全球市場，建立並提升本土品牌進入國際市場的全球影響力。
        </div>
        <div class="list-box">
            <div class="item-box">
                <img src="../assets/img-8.png" alt="">
                <div class="text-1">營銷策略定制</div>
                <div class="line-1"></div>
                <div class="text-2">提供定制化文案，包含競品與市場定位分析、目標用戶分析、本地市場分析與洞察等。</div>
            </div>
            <div class="item-box">
                <img src="../assets/img-9.png" alt="">
                <div class="text-1">海外社交媒體運營</div>
                <div class="line-1"></div>
                <div class="text-2">提供一站式社媒體運營解決方案，助力您的企業打開海外市場，打破海外文化壁壘，增加海外用戶粘性，提升品牌海外私域流量。</div>
            </div>
            <div class="item-box">
                <img src="../assets/img-10.png" alt="">
                <div class="text-1">數字媒體廣告投放</div>
                <div class="line-1"></div>
                <div class="text-2">專業優化師團隊操作，紅人素材+廣告投放，提高網站付費&自然流量，助力您的品牌觸及更多潛在客戶。</div>
            </div>
            <div class="item-box">
                <img src="../assets/img-11.png" alt="">
                <div class="text-1">解決方案</div>
                <div class="line-1"></div>
                <div class="text-2">幫助出海企業進軍海外市場，為出海企業提供全方位品牌出海策略，專業執行團隊打造全鏈服務，深度契合目標市場，助力企業連接世界。</div>
            </div>
        </div>
        <footerBox></footerBox>
    </div>
</template>
<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
    name: 'App',
    components: {
        menuBox,
        footerBox,
    },
    data() {
        return {
        }
    },
    mounted() {

    },
    methods: {

    }
}
</script>
<style lang="less" scoped>
.core_strengths{
    background: #F5F5F5;
}
.banner{
    width: 100%;
}
.text{
    font-size: 24px;
    font-weight: 500;
    color: #999999;
    padding: 120px 360px 0px 360px;
}
.list-box{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 80px 300px 120px 300px;
    .item-box{
        width: 304px;
        height: 460px;
        background: #FFFFFF;
        display: flex;
        flex-direction: column;
        align-items: center;
        img{
            width:80px ;
            margin-top: 67px;
        }
        .text-1{
            font-size: 24px;
            font-weight: 500;
            color: #333333;
            margin-top: 48px;
        }
        .line-1{
            width: 22px;
            height: 4px;
            background:#1C539D ;
            margin-top: 24px;
        }
        .text-2{
            margin-top: 24px;
            padding: 0px 21px;
            font-size: 18px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #999999;
        }

    }
}
</style>